module.exports = __webpack_public_path__ + "img/28_35.fa317b72.png";